import BaseClass from "../BaseClass.js";
import {GiphyFetch} from "@giphy/js-fetch-api";

export default class GifsHandler extends BaseClass {
    constructor(element) {
        super(element);
        this.gifButtonClickListener = null;
        this.isGifLoading = false;
        this.gifLoadingLimit = 25;
        this.gifLoadingOffset = 0;
        this.gifSearch = null;
        this.gf = new GiphyFetch(process.env.MIX_GIPHY_API_KEY);

        // gif button
        this.targetElementId = null;
        // gif container
        this.$target = null;

        // messenger: conversation id
        this.contentId = null;
        // messenger: participant id
        this.sendTo = null;

        this.eventName = 'message:send_gif';
        this.init();
    }

    init() {
        let mySelf = this;

        this.targetElementId = this.$element.attr('data-target-id');
        this.$target = $('#' + this.targetElementId);

        const contentId = this.$element.attr('data-content-id');
        if (contentId != undefined) {
            this.contentId = contentId;
        }

        const sendTo = this.$element.attr('send_to');
        if (sendTo != undefined) {
            this.sendTo = sendTo;
        }

        const chatType = this.$element.attr('type');
        if (chatType != undefined && chatType == 'camchat') {
            this.eventName = 'camchat:send_gif';
        }

        this.gifButtonClickListener = async function (event) {
            await mySelf.openGifsHandler();
        }

        this.$element.on('click', this.gifButtonClickListener);

        const $closeButton = this.$target.find('[data-id="gif-close-btn"]');
        $closeButton.on('click', function () {
            mySelf.closeGifHandler();
        });
    }

    closeGifHandler() {
        let mySelf = this;

        let $giphyContainer = this.$target;
        let $gifGridContainer = $giphyContainer.find('[data-id="gif-grid"]').first();

        $giphyContainer.addClass('hidden');
        $gifGridContainer.html('');
        mySelf.isGifLoading = false;
        mySelf.gifLoadingOffset = 0;
        mySelf.gifSearch = null;
        const $searchInput = $giphyContainer.find('[data-type="gif_search_input"]').first();
        $searchInput.val('');

        window.removeEventListener('resize', () => {
            mySelf.handleResize();
        });
    }


    async openGifsHandler() {
        let mySelf = this;

        let $giphyContainer = this.$target;
        let $gifGridContainer = $giphyContainer.find('[data-id="gif-grid"]').first();

        if ($giphyContainer.hasClass('hidden')) {
            // open
            mySelf.initGifSearch();
            $giphyContainer.removeClass('hidden');
            await mySelf.loadGifs(this.gifLoadingLimit, this.gifLoadingOffset);

            window.addEventListener('resize', () => {
                mySelf.handleResize();
            });

            mySelf.setupInfiniteScroll($gifGridContainer);
        } else {
            // close
            mySelf.closeGifHandler();
        }
    }

    handleResize() {
        const gifWrappers = this.$target.find('.gif-wrapper');

        gifWrappers.each(function () {
            const gifImg = $(this).find('img')[0];
            if (gifImg) {
                let span = Math.ceil(gifImg.getBoundingClientRect().height / 2);
                span += 1;
                $(this).css('grid-row-end', `span ${span}`);
            }
        });
    }

    async loadGifs(limit, offset, reset = false) {
        let mySelf = this;
        let $giphyContainer = this.$target;
        let $gifGridContainer = $giphyContainer.find('[data-id="gif-grid"]').first();

        if (!$gifGridContainer) {
            console.error('Gif grid container not found!');
            return;
        }

        if ($gifGridContainer.offsetWidth == 0) {
            console.error('Gif grid container has zero width. Make sure it is visible.');
            $gifGridContainer.html('Container is not visible or has zero width.');
            return;
        }

        if (reset) {
            $gifGridContainer.html('');
            this.gifLoadingOffset = 0;
        }

        if (this.isGifLoading) {
            return;
        }
        this.isGifLoading = true;

        try {
            let gifs;
            // request to GIPHY API
            if (this.gifSearch != null) {
                const response = await this.gf.search(this.gifSearch, {limit: limit, offset: offset});
                gifs = response.data;
            } else {
                const response = await this.gf.trending({limit: limit, offset: offset});
                gifs = response.data;
            }

            // render gifs
            gifs.forEach((gif) => {
                let $gifWrapper = $('<div>', {class: 'gif-wrapper'});

                let $gifImg = $('<img>', {
                    src: gif.images.fixed_width.url,
                    alt: gif.title || 'GIF',
                    'data-gif': JSON.stringify(gif)
                });

                $gifImg.on('load', function () {
                    let span = Math.ceil(this.getBoundingClientRect().height / 2) + 1;
                    $gifWrapper.css('grid-row-end', `span ${span}`);
                });

                $gifWrapper.append($gifImg);
                $gifGridContainer.append($gifWrapper);
            });

            this.gifLoadingOffset += gifs.length;

        } catch (error) {
            console.error('Error by gifs loading: ', error);
            $gifGridContainer.html('Error gifs loading');
        } finally {
            this.isGifLoading = false;
        }

        $gifGridContainer.off('click', '.gif-wrapper img').on('click', '.gif-wrapper img', function () {
            let gifData = $(this).data('gif');
            if (gifData) {
                mySelf.gifSelected(gifData);
            }
        });
    }

    setupInfiniteScroll($gifGridContainer) {
        let mySelf = this;

        $gifGridContainer.on('scroll', debounce(async () => {
                const scrollTop = $gifGridContainer.scrollTop();
                const scrollHeight = $gifGridContainer.prop('scrollHeight');
                const clientHeight = $gifGridContainer.prop('clientHeight');

                if (scrollTop + clientHeight >= scrollHeight - 25) {
                    await mySelf.loadGifs(mySelf.gifLoadingLimit, mySelf.gifLoadingOffset);
                }
            }, 100)
        );
    }

    initGifSearch() {
        let mySelf = this;
        let $giphyContainer = this.$target;
        const $searchInput = $giphyContainer.find('[data-type="gif_search_input"]').first();
        const $searchBtn = $giphyContainer.find('[data-type="gif_search_btn"]').first();
        const $clearBtn = $giphyContainer.find('[data-type="gif_search_clear_btn"]').first();

        $searchInput.on('input', () => {
            if ($searchInput.val().trim() != '') {
                $clearBtn.addClass('visible');
            } else {
                $clearBtn.removeClass('visible');
            }
        });

        // remove search query, restart gif loading (trending)
        $clearBtn.on('click', async () => {
            $searchInput.val('');
            mySelf.gifSearch = null;
            $clearBtn.removeClass('visible');
            await mySelf.loadGifs(mySelf.gifLoadingLimit, 0, true);
        });

        // search button click
        $searchBtn.on('click', async function () {
            const query = $searchInput.val().trim();
            mySelf.gifSearch = query;
            await mySelf.loadGifs(mySelf.gifLoadingLimit, 0, true);
        });

        // press enter in search input
        $searchInput.on('keypress', async function (e) {
            if (e.which == 13) {
                const query = $(this).val().trim();
                mySelf.gifSearch = query;
                await mySelf.loadGifs(mySelf.gifLoadingLimit, 0, true);
            }
        });
    }

    gifSelected(gif) {
        if (this.contentId != null) {
            const enhancedEvent = {
                originalEvent: event,
                contentId: this.contentId,
                sendTo: this.sendTo,
                gif: gif
            };

            $(document).trigger(this.eventName, enhancedEvent);
        }

        if (this.eventName == 'camchat:send_gif') {
            this.closeGifHandler();
        }
    }

    destroyListener() {
        this.$element.off('click', this.gifButtonClickListener);
    }
}